import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLayout } from '#src/layouts/rewards/RewardsFixtureLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const RewardsFixtureLayoutPage = () => {
  const { fixture, league, quality, rarity } = useTypedParams<LayoutParams>();
  return (
    <RewardsFixtureLayout
      fixture={fixture}
      league={league}
      quality={quality}
      rarity={rarity}
    />
  );
};

export default RewardsFixtureLayoutPage;
